import { render, staticRenderFns } from "./RoleEditModal.vue?vue&type=template&id=f7ac3856"
import script from "./RoleEditModal.vue?vue&type=script&lang=js"
export * from "./RoleEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports